import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowDown, CheckCircle2, Sparkles } from 'lucide-react';
import ServicesGridBento from '../components/ServicesGridBento';
import ServicesGridDuo from '../components/ServicesGridDuo';
import ServicesGridStripe from '../components/ServicesGridStripe';

const VARIANTS = [
  {
    id: 'A',
    name: 'Bento Grid (Asimetrik premium)',
    desc: 'Apple/Linear tarzı asimetrik düzen. Business VoIP 2x büyük hero kart + canlı dashboard mockup. Hover\'da yumuşak yükselme. Servis başına farklı renk vurgusu.',
    pros: ['Çok modern, premium hissi', 'Hiyerarşi net', 'Hero kart dikkat çekiyor'],
    cons: ['12 sütunlu grid mobilde stack olur (sorun değil ama)'],
    Component: ServicesGridBento,
  },
  {
    id: 'B',
    name: 'Dark/Light Mix (Cesur kontrast)',
    desc: '3 önemli servis (VoIP, Teams, Outbound) koyu mor/mavi/rose gradient kartlarda — diğerleri açık zeminde kendi renkleriyle. Her kartta fiyat rozeti.',
    pros: ['Hemen göze çarpıyor', 'Cesur ve hatırlanır', 'Fiyat erken görünüyor → conversion'],
    cons: ['Çok renkli (bazı kullanıcılar için yorucu olabilir)'],
    Component: ServicesGridDuo,
  },
  {
    id: 'C',
    name: 'Stripe-style + Illustrations (Profesyonel)',
    desc: 'Stripe/Vercel tarzı yatay kartlar — solda metin + bullet + fiyat, sağda her servise özel SVG illüstrasyon. Üstte ince gradient şerit + sosyal kanıt rozeti.',
    pros: ['En profesyonel görünüm', 'Sosyal kanıt entegre', 'İllüstrasyonlar serviceleri anlatıyor'],
    cons: ['Daha uzun kart → daha fazla scroll', 'Mobilde illüstrasyon gizleniyor'],
    Component: ServicesGridStripe,
  },
];

export default function DesignPreview() {
  return (
    <div className="bg-slate-50 min-h-screen">
      <header className="bg-gradient-to-br from-violet-950 via-violet-900 to-fuchsia-900 text-white">
        <div className="container-x py-16 md:py-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-xs font-bold uppercase tracking-wider mb-4">
            <Sparkles size={12} /> Design preview
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-4">
            Services bölümü için <span className="bg-clip-text text-transparent bg-gradient-to-r from-fuchsia-300 to-amber-200">3 farklı tasarım</span>
          </h1>
          <p className="text-violet-100 text-lg max-w-2xl">
            Aşağıda 3 farklı yön karşılaştırmalı olarak görüntüleniyor. Beğendiğinizi belirtin — anasayfaya canlı uygulayalım.
          </p>

          <div className="flex flex-wrap gap-3 mt-8">
            {VARIANTS.map((v) => (
              <a
                key={v.id}
                href={`#variant-${v.id}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/15 backdrop-blur border border-white/15 text-sm font-bold transition"
              >
                Yön {v.id} <ArrowDown size={12} />
              </a>
            ))}
            <Link to="/" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400 text-amber-950 font-extrabold text-sm hover:bg-amber-300 transition">
              Mevcut tasarım (anasayfa)
            </Link>
          </div>
        </div>
      </header>

      {VARIANTS.map((v) => (
        <section key={v.id} id={`variant-${v.id}`} className="border-b border-slate-200">
          <div className="container-x pt-12 pb-2">
            <div className="flex flex-wrap items-baseline gap-3">
              <span className="text-7xl font-extrabold bg-clip-text text-transparent bg-gradient-to-br from-violet-500 to-fuchsia-500 leading-none">{v.id}</span>
              <div>
                <h2 className="text-3xl font-extrabold leading-tight">{v.name}</h2>
                <p className="text-slate-600 mt-1 max-w-3xl">{v.desc}</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {v.pros.map((p) => (
                    <span key={p} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold">
                      <CheckCircle2 size={12} /> {p}
                    </span>
                  ))}
                  {v.cons.map((c) => (
                    <span key={c} className="px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-semibold">
                      − {c}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* Render the actual variant */}
          <v.Component />
        </section>
      ))}

      <footer className="bg-slate-900 text-slate-300">
        <div className="container-x py-12 text-center">
          <p className="text-lg">Hangi tasarımı beğendiniz?</p>
          <p className="text-slate-500 mt-2 text-sm">Yön A / B / C cevabınızı söyleyin — hemen anasayfaya canlı uygulayalım.</p>
          <Link to="/" className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-full bg-violet-500 hover:bg-violet-400 text-white font-bold text-sm transition">
            Anasayfaya dön
          </Link>
        </div>
      </footer>
    </div>
  );
}
